enum Basket {
  NoCheckoutEmptyBasket = "PBCTANoCheckoutEmptyBasket",
  CreatePaymentFailed = "PBCTACreatePaymentFailed"
}

export default Basket
